var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconButtonVersao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.3 24.1",
    style: {
      enableBackground: "new 0 0 23.3 24.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.9,4.7c0.4-2.5,0.7-2.8,3.3-2.8c1.6,0,3.2-0.1,4.7,0c1,0.1,2,0.5,2.8,1.1c1.3,1,2.4,2.2,3.5,3.4c0.5,0.6,0.9,1.5,1,2.2 c0.1,2.9,0.1,5.8,0,8.6c-0.1,2.5-0.4,2.7-3,3c-0.1,0.4-0.2,0.9-0.3,1.3c-0.3,1-0.9,1.5-2,1.5c-3.6,0-7.2,0-10.9,0 c-1.2,0-1.9-0.6-2-1.7c-0.1-0.6-0.1-1.2-0.1-1.8c0-3.9,0-7.8,0-11.6C2.9,5.3,3.2,5,5.9,4.7z M20,7.9c-1.3,0-2.5,0-3.7,0 c-1,0-1.5-0.2-1.5-1.2c0-0.8,0-1.5,0-2.3c0.1-1.1-0.3-1.6-1.4-1.5c-1.7,0-3.3,0.1-5,0C7.3,2.8,7,3.3,7,4.4c0.1,2.4,0.1,4.7,0.1,7.1 c0,2.1-0.1,4.2-0.1,6.2c0,0.7-0.1,1.5,1.1,1.5c3.6,0,7.2,0,10.9,0c0.7,0,1-0.3,1-0.9C20,14.9,20,11.5,20,7.9z M4,13.9 C4,13.9,4,13.9,4,13.9c0,2.3,0,4.6,0,7c0,0.7,0.2,1.2,1,1.2c3.6,0,7.2,0,10.9,0c0.8,0,1.1-0.4,1.1-1.1c0-0.8-0.6-0.7-1.1-0.7 c-2.2,0-4.5,0-6.7,0c-2.4,0-3.1-0.6-3.1-3c0-3.4,0-6.7,0-10.1c0-0.6,0.2-1.3-0.8-1.3C4.2,5.8,4,6.3,4,7.1C4,9.4,4,11.7,4,13.9z  M19,6.8c-1-1.1-1.8-2-2.7-2.9C16.2,4,16.2,4,16.1,4.1c0,0.9,0,1.8,0,2.8C17.1,6.8,18,6.8,19,6.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonVersao);
export default __webpack_public_path__ + "static/media/iconButtonVersao.96ae047a.svg";
export { ForwardRef as ReactComponent };